// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"921c727f","532":"d6343abc","971":"d6343abc"}[chunkId] + ".chunk.css";
};